import Button from 'atoms/Button';
import { observer } from 'mobx-react-lite';
import React from 'react';

import s from '../Notifications.module.scss';

const NotificationFooter = ({
  onLoadMore,
  setReadAll
}: {
  hasMore?: boolean;
  onLoadMore?: () => void;
  setReadAll?: () => void;
}) => {
  return (
    <div className={s.Notifications__footer}>
      <Button
        style={{
          fontSize: 14,
          fontWeight: 500,
          color: '#1ea0c0'
        }}
        disabled={!onLoadMore}
        variant="text"
        onClick={(e) => {
          onLoadMore && onLoadMore();
          e.stopPropagation();
        }}
      >
        {'Load more'}
      </Button>
      <Button
        style={{
          fontSize: 14,
          fontWeight: 500,
          color: '#1ea0c0'
        }}
        disabled={!setReadAll}
        variant="text"
        onClick={(e) => {
          setReadAll && setReadAll();
          e.stopPropagation();
        }}
      >
        {'Mark all as read'}
      </Button>
    </div>
  );
};

export default observer(NotificationFooter);
